<template>
  <div class="role-filter" v-if="_allUserRoles.length">
    <multiselect
      style="width: 150px;"
      v-model="currentFilter"
      :options="getOptionsFilter"
      track-by="name"
      label="display_name"
      :showLabels="false"
      multiple
      allow-empty
      ref="multiselect"
    >
      <template slot="option" slot-scope="props">
        <div class="option__desc" @click.stop="selectRole(props.option, props)">
          {{ props.option.display_name }}
        </div>
      </template>
      <template slot="selection" slot-scope="{ values, isOpen }">
        <span class="multiselect__single" v-if="values.length > 1 && !isOpen">
          {{ values.length }}/{{ getOptionsFilter.length }}
        </span>
        <span class="multiselect__single" v-if="values.length === 1 && !isOpen">
          {{ values[0].display_name }}
        </span>
      </template>
      <template slot="tag"><i></i></template>
    </multiselect>
  </div>
</template>

<script>
export default {
  data () {
    return {
      currentFilter: [{ display_name: 'All', name: 'all' }],
      config: {
        mockFilters: {
          all: {
            display_name: 'All',
            name: 'all'
          }
        },
        mockPdBindFilters: [
          'business_analyst',
          'designer',
          'developer',
          'project_manager',
          'qa'
        ]
      }
    }
  },
  props: {
    data: {
      type: Array
    },
    onlyProdDep: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getOptionsFilter () {
      let userRoles = []
      if (this.onlyProdDep) {
        userRoles = this._prodDepUserRoles
      } else {
        userRoles = this._allUserRoles
      }
      return [
        this.config.mockFilters.all,
        ...userRoles
      ]
    }
  },
  created () {
    if (this.data) this.setInitData()
  },
  methods: {
    setInitData () {
      this.currentFilter = [...this.data]
    },
    selectRole (event) {
      this.$refs.multiselect.toggle()

      if (event.name === this.config.mockFilters.all.name) {
        this.currentFilter = [this.config.mockFilters.all]
        this.emitSelected()
        return
      }

      if (event.name !== this.config.mockFilters.all.name) {
        let fcTabs = {
          addRole: () => {
            this.currentFilter.push(event)
            this.currentFilter = this.currentFilter.filter(item => item.name !== this.config.mockFilters.all.name)
          },
          removeRole: () => {
            if (this.currentFilter.length === 1) {
              this.currentFilter = [this.config.mockFilters.all]
              return
            }

            this.currentFilter = this.currentFilter.filter(item => item.name !== event.name)
          }
        }

        const isSelected = this.currentFilter.some(item => item.name === event.name)
        const status = isSelected ? 'removeRole' : 'addRole'
        fcTabs[status]()
      }

      this.emitSelected()
    },
    emitSelected () {
      this.$emit('selected', this.currentFilter)
    }
  }
}
</script>
